import React from "react"


class PaddingInput extends React.Component {

  constructor(props) {
    super(props)
    this._onStyleChange = this._onStyleChange.bind(this);
  }

  render() {
    return (
      <div></div>
    );
  }

  _onStyleChange(color) {
    var padding = '';
    this.props.onStyleChange(PageBuilderConstants.PADDING, padding);
  }

};

export default PaddingInput
